"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NavbarBrand["default"];
  }
});
var _NavbarBrand = _interopRequireDefault(require("react-bootstrap/lib/NavbarBrand"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/NavbarBrand.js
// module id = 6410
// module chunks = 25